import { Info } from "@phosphor-icons/react";

import Skeleton from "common/components/ui/Skeleton";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";

import type { ReactNode } from "react";

interface EstimateRowProps {
  label: string;
  tooltipText: string;
  valueComponent: ReactNode;
  isLoading: boolean;
}

export function EstimateRow({
  label,
  tooltipText,
  valueComponent,
  isLoading,
}: EstimateRowProps) {
  return (
    <div className="flex items-center justify-between px-2.5 grow">
      <div className="flex items-center gap-x-0.5">
        <span className="text-button-sm text-black-600">{label}</span>
        <Tooltip>
          <TooltipTrigger>
            <Info weight="fill" className="text-black-300 size-4" />
          </TooltipTrigger>
          <TooltipContent>{tooltipText}</TooltipContent>
        </Tooltip>
      </div>
      <div className="gap-x-0.5 flex">
        {isLoading ? <Skeleton className="w-24 h-5" /> : valueComponent}
      </div>
    </div>
  );
}
